import privacySetting from "@/views/privacySetting/privacySetting.vue";
import createPrivacySetting from "@/views/privacySetting/createPrivacySetting.vue";
import EditPrivacySetting from "@/views/privacySetting/editPrivacySetting.vue";

export default {
  path: "privacy-setting",
  meta: { label: "Privacy Setting" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: privacySetting,
    },
    {
      path: "createPrivacySetting",
      name: "Create Privacy Setting",
      meta: {
        requiresAuth: true,
      },
      component: createPrivacySetting,
    },
    {
      path: "editPrivacySetting",
      name: "Edit Privacy Setting",
      meta: {
        requiresAuth: true,
      },
      component: EditPrivacySetting,
      props: true,
    },
  ],
};
